module.exports = __webpack_public_path__ + "img/cooked.0d88f696.png";